import { clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Utility function to merge Tailwind CSS classes
 * Combines clsx for conditional classes with tailwind-merge for proper class merging
 *
 * @param {...any} inputs - Class names or conditional class objects
 * @returns {string} Merged class string
 *
 * @example
 * cn('px-2 py-1', 'bg-blue-500')
 * cn('px-2', condition && 'bg-blue-500')
 * cn({ 'bg-blue-500': isActive }, 'px-2')
 */
export function cn(...inputs) {
    return twMerge(clsx(inputs));
}
